import {
    Component,
    OnInit,
    ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Key } from './key';
import { FormControl } from '@angular/forms';

//import { AppState } from '/Users/User/Documents/zeiza-site/src/app/app.service';
//import { Title } from '../title';

@Component({
    selector: 'keys',
    styleUrls: ['./keys.component.scss'],
    templateUrl: './keys.component.pug'
})
export class KeysComponent implements OnInit {
    @ViewChild('keysTable') table: any;

    public keys: Key[] = [];
    public expanded: any = {};
    public currentState: any;
    public keyCreationMode: boolean = false;
    public numberOfPcsControl: number = 1;
    public daysControl: number = 30;
    public commentControl: string = '';
    public keyControl: string = '';
    public errorMessage: string;
    public email: string;
    public regularKey: string;

    public localState: any;
    constructor(
        public route: ActivatedRoute,
        public translate: TranslateService,
        private http: HttpClient

    ) {
    }

    public sendKey() {
        this.http.post(remoteApiHost + 'api/admin/createKey', {
            numberOfPcs: this.numberOfPcsControl,
            days: this.daysControl,
            comment: this.commentControl,
            key: this.keyControl
        }).subscribe((data: any) => {
            let newKey = new Key(this.http);
            newKey.numberOfPcs = data.numberOfPcs;
            newKey.activations = data.child.children;
            newKey.invoiceGuid = data.invoiceGuid;
            newKey.created = data.created;
            newKey.keyGuid = data.child.key;
            newKey.comment = data.comment;
            this.keys = [...this.keys, newKey];
            this.keyCreationMode = false;
        }, (err) => {
            this.errorMessage = "Key is already activated!";
            this.keyCreationMode = true;
        });
    }

    public generateRegular() {
        this.http.post(remoteApiHost + 'api/admin/generateregular', {
            email: this.email
        }).subscribe((data) => {
            this.regularKey = (data as any).key;
        });
    }

     public createKey() {
        this.keyCreationMode = true;
    }

    public toggleExpandRow(row) {
        this.table.rowDetail.toggleExpandRow(row);
      }
    public onDetailToggle(event) {
        console.log('Detail Toggled', event);
      }

    public ngOnInit() {
        this.http.get(remoteApiHost + 'api/admin/getInvoice').subscribe((data: any) => {
            this.keys = [];
            for (let i of data) {
                if (i.child) {
                    let key = new Key(this.http);
                    key.numberOfPcs = i.numberOfPcs;
                    key.activations = i.child.children;
                    key.invoiceId = i._id;
                    key.invoiceGuid = i.invoiceGuid;
                    key.created = i.created;
                    key.keyGuid = i.child.key;
                    key.comment = i.comment;
                    this.keys.push(key);
                }
            }
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/admin/keys/keys.component.ts